module.exports = __webpack_public_path__ + "img/015.d507a2fe.png";